import { useRef, useState } from "react";
import {
    useVrboSyncPropertyImagesMutation,
    useVrboSyncUnitSpacesMutation,
    useVrboUpdatePropertyMutation,
    useVrboUpdateUnitMutation,
    useVrboUpdateUnitRegistrationMutation,
} from "../../../services/bClientApi";
import useVrboAction from "../useVrboAction";
import VrboActionRow from "../VrboActionRow";
import VrboUpdatePropertyModal from "../VrboUpdatePropertyModal";
import { VrboUpdatePropertyOptions } from "../VrboUpdatePropertyOptionsForm";

export default function VrboListingSection(props: { propertyId: string, onSynced: () => void }) {
    const { propertyId, onSynced } = props

    const [updateProperty] = useVrboUpdatePropertyMutation()
    const [updateUnit] = useVrboUpdateUnitMutation()
    const [updateUnitRegistration] = useVrboUpdateUnitRegistrationMutation()
    const [syncImages] = useVrboSyncPropertyImagesMutation()
    const [syncUnitSpaces] = useVrboSyncUnitSpacesMutation()

    const enabled = !!propertyId

    const [isSelectingUpdate, setIsSelectingUpdate] = useState(false)
    const updatePropertyOptions = useRef<VrboUpdatePropertyOptions | undefined>(undefined)

    const updatePropertyAction = useVrboAction(
        () => updateProperty({ propertyId, options: updatePropertyOptions.current }).unwrap(),
        { errorLabel: 'updating VRBO property', enabled, onSuccess: onSynced },
    )
    const updateUnitAction = useVrboAction(
        () => updateUnit(propertyId).unwrap(),
        { errorLabel: 'updating VRBO unit', enabled },
    )
    const unitRegistrationAction = useVrboAction(
        () => updateUnitRegistration(propertyId).unwrap(),
        { errorLabel: 'updating VRBO unit registration', enabled },
    )
    const syncImagesAction = useVrboAction(
        () => syncImages(propertyId).unwrap(),
        { errorLabel: 'syncing VRBO property images', enabled },
    )
    const syncUnitSpacesAction = useVrboAction(
        () => syncUnitSpaces(propertyId).unwrap(),
        { errorLabel: 'syncing VRBO unit spaces', enabled },
    )

    return (
        <div>
            <VrboActionRow
                action={updatePropertyAction}
                variant="secondary"
                label="Update Property"
                busyLabel="Updating..."
                resultTitle="Update Property Response"
                onClick={() => setIsSelectingUpdate(true)}
            />
            <VrboUpdatePropertyModal
                active={isSelectingUpdate}
                onClose={() => setIsSelectingUpdate(false)}
                onConfirm={(options) => {
                    updatePropertyOptions.current = options
                    setIsSelectingUpdate(false)
                    updatePropertyAction.run()
                }}
            />
            <VrboActionRow action={updateUnitAction} label="Update Unit" busyLabel="Updating..." resultTitle="Update Unit Response" />
            <VrboActionRow action={unitRegistrationAction} label="Update Unit Registration" busyLabel="Updating..." resultTitle="Unit Registration" />
            <VrboActionRow action={syncImagesAction} label="Sync Images" busyLabel="Syncing..." resultTitle="Sync Images" />
            <VrboActionRow action={syncUnitSpacesAction} label="Sync Unit Spaces" busyLabel="Syncing..." resultTitle="Sync Unit Spaces" />
        </div>
    )
}
